module.exports = __webpack_public_path__ + "static/media/Dayly_ios_3_preview.52522e00.jpg";